import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import {categoryHref} from 'lib/categories';
import Icon from './Icon';
import styles from './topics.module.scss';

function count(num) {
  const label = num === 1 ? 'article' : 'articles';

  return `${num} ${label}`;
}

const Topic = ({category}) => (
  <Link className={styles.Topic} to={categoryHref(category)}>
    <div className={styles.Topic__header}>
      <Icon category={category} />
      <p className={styles.Topic__count}>{count(category.articleCount)}</p>
    </div>
    <div className={styles.Topic__content}>
      <h3 className={styles.Topic__name}>{category.name}</h3>
      {category.description && (
        <p className={styles.Topic__description}>{category.description}</p>
      )}
    </div>
  </Link>
);

Topic.propTypes = {
  category: PropTypes.shape({
    articleCount: PropTypes.number.isRequired,
    description: PropTypes.string,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default Topic;



// WEBPACK FOOTER //
// ./src/components/topics/Topic.js